import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {ClientBanksModel} from "./client-banks.model";

@Injectable()
export class ClientBanksService implements IDataModel {

    private API_ROOT:string = '/clients/bank';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<ClientBanksModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientBanksModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/bank`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }


    getOneByClient(clientId:number): Observable<ResponseModel<ClientBanksModel>>  {
        return this.http.get(`/clients/${clientId}/bank`).map((res) => res.json());
    }

    getOne(id:number):Observable<ResponseModel<ClientBanksModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:ClientBanksModel): Observable<ResponseModel<ClientBanksModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:ClientBanksModel): Observable<ResponseModel<ClientBanksModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/client-banks/client-banks.service.ts